import React from 'react'

const Discount = () => {
  return (
    <div>Discount</div>
  )
}

export default Discount